"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemFunctionSettings = exports.SystemFunctionDataSource = exports.PROJECT_NAME = exports.SystemEnvironment = void 0;
var SystemEnvironment;
(function (SystemEnvironment) {
    SystemEnvironment["DEVELOPMENT"] = "development";
    SystemEnvironment["PRODUCTION"] = "production";
    SystemEnvironment["TEST"] = "test";
})(SystemEnvironment = exports.SystemEnvironment || (exports.SystemEnvironment = {}));
exports.PROJECT_NAME = process.env.PROJECT_NAME;
var SystemFunctionDataSource;
(function (SystemFunctionDataSource) {
    SystemFunctionDataSource["COMMON"] = "COMMON";
    SystemFunctionDataSource["DF0001"] = "DF0001";
})(SystemFunctionDataSource = exports.SystemFunctionDataSource || (exports.SystemFunctionDataSource = {}));
exports.SystemFunctionSettings = Object.keys(SystemFunctionDataSource).reduce((key, value) => (Object.assign(Object.assign({}, key), { [value]: exports.PROJECT_NAME === 'true' ? value.toLowerCase() : value })), SystemFunctionDataSource);
